import Heading from '@atlaskit/heading';
import Link from '@atlaskit/link';
import { Box, Stack, Text, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import chatImage from '../../../assets/chat.svg';
import { useRovoDevWebAnalyticsClient } from '../../../controllers/rovo-dev-web-analytics-events';

export const Feedback = () => {
	const { fireUiEvent } = useRovoDevWebAnalyticsClient();
	return (
		<Box xcss={feedbackSectionWrapper}>
			<Box xcss={feedbackCardStyles}>
				<Box xcss={textWrapperStyles}>
					<Stack space="space.150">
						<Heading size="medium" testId="feedback-section-heading">
							Talk to the community
						</Heading>
						<Text as="p">
							Join our Rovo Dev Agents group to ask questions and get advice from product experts.
						</Text>
						<Link
							href="https://community.atlassian.com/forums/Rovo-Dev-AI-Agents-Beta/gh-p/rovo-dev-ai-agents"
							appearance="subtle"
							target="_blank"
							onClick={() => {
								fireUiEvent({
									action: 'clicked',
									actionSubject: 'link',
									actionSubjectId: 'community-link',
									source: 'home-page-feedback',
								});
							}}
						>
							Visit the Rovo Dev Agents group
						</Link>
					</Stack>
				</Box>
			</Box>
		</Box>
	);
};

const feedbackCardStyles = xcss({
	padding: 'space.600',
	backgroundColor: 'elevation.surface.overlay',
	'::after': {
		content: '""',
		position: 'absolute',
		top: '-10px',
		right: 'space.0',
		width: '198px',
		height: '198px',
		background: `url(${chatImage}) no-repeat`,
	},
	position: 'relative',
	borderRadius: 'border.radius.100',
	border: `1px solid ${token('color.border')}`,
});

const feedbackSectionWrapper = xcss({
	paddingTop: 'space.500',
});

const textWrapperStyles = xcss({
	width: 'calc(100% - 150px)',
});
